import { render } from "./ImgCutter.vue?vue&type=template&id=59da550c&scoped=true"
import script from "./ImgCutter.vue?vue&type=script&lang=js"
export * from "./ImgCutter.vue?vue&type=script&lang=js"

import "./ImgCutter.vue?vue&type=style&index=0&id=59da550c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59da550c"]])

export default __exports__